import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03da4cd6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=03da4cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03da4cd6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/Users/daiyu/Desktop/work-code/bantervideo/components/Loading/index.vue').default})
